/*!
 *  - howto.js
 * @generated Mon Mar 06 2023 17:44:06 GMT+0900 (GMT+09:00)
 */
'use strict';

(function ($, DCM, cssua) {
	var a = 'is-active';
	var v = 'is-visible';
	var slideSpeed = '400';

	DCM = {
		va: {
			pathname: location.pathname,
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		gardenMainSlide: function gardenMainSlide() {
			$('.howto-garden-main-slide').slick({
				autoplay: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: '<a class="slick-prev" href="#"><i class="icon icon-arrow_left"></i></a>',
				nextArrow: '<a class="slick-next" href="#"><i class="icon icon-arrow_right"></i></a>',
				dots: true,
				centerMode: true,
				infinite: true,
				variableWidth: true,
				loop: true,
				responsive: [{
					breakpoint: 768,
					settings: {
						centerMode: false,
						variableWidth: false
					}
				}]
			});

			$('.howto-detail-slide').slick({
				autoplay: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: '<a class="slick-prev" href="#"><i class="icon icon-arrow_left"></i></a>',
				nextArrow: '<a class="slick-next" href="#"><i class="icon icon-arrow_right"></i></a>',
				dots: true,
				infinite: true,
				loop: true
				// appendArrows: $('.howto-detail-slide')
			});
		},
		gardenDetailRecommend: function gardenDetailRecommend() {
			// JSON取得 ---------------------------------------------------
			// おすすめ植物取得用
			var getJSONRecommend = function getJSONRecommend(_cat) {
				return $.getJSON('/ajax/garden/' + _cat + '.json');
			};

			if (DCM.va.pathname.indexOf('/howto/garden/') !== -1) {
				if ($('.js-recommend').length) {

					var thisID = location.pathname.split('/')[4].replace(/\.html/, '');
					var $cat = DCM.va.pathname.split('/')[3];
					var recoHTML = '';

					getJSONRecommend($cat).then(function (data) {
						var recommendList = data.rt_bn_garden_memo_list,
						    recommendListLen = recommendList.length,
						    arr = [];

						if (recommendListLen > 1) {
							for (var i = 0; i < recommendListLen; i++) {
								if (thisID !== recommendList[i]._key) {
									arr.push(recommendList[i]._key);
								}
							}

							// 「～の記事一覧」ボタン描画
							$('.js-catBtn').html('<a href="/howto/garden/' + $cat + '/"\n\t\t\t\t\t\t\tclass="js-catBtn mod-btn mod-btn_left"><i class="icon icon-arrow_left"></i>\n\t\t\t\t\t\t\t' + recommendList[0].cf_gm_category.cf_gmca_name + '\u306E\u8A18\u4E8B\u4E00\u89A7</a>');

							// ランダムに3件を選んで表示
							var selectList = arr.slice().sort(function () {
								return Math.random() - 0.5;
							}).slice(0, 3);

							for (var _i = 0; _i < recommendListLen; _i++) {
								var title = recommendList[_i].cf_gm_title,
								    key = recommendList[_i]._key,
								    img = recommendList[_i].cf_gm_thumb_img,
								    tagList = recommendList[_i].cf_gm_tags;

								if (selectList.indexOf(key) !== -1) {

									recoHTML += '<li class="pure-u-1-3 pure-u-md-1-1 space-u-40-child">' + ('<a href="/howto/garden/' + $cat + '/' + key + '.html" class="mod-newsItem mod-a">') + ('<figure><img src="/garden_memo_file/file/' + img + '" class="" alt="' + title + '"></figure>') + '<p class="mod-newsItem-howto">ガーデンメモ</p>' + ('<p class="mod-newsItem-title mt10">' + title + '</p></a><div class="mod-newsItem-tag mt10">');

									if (tagList !== undefined && tagList !== null && tagList !== '') {
										if (tagList.length !== 0) {
											recoHTML += '<i class="icon icon-tag"></i><ul>';
											for (var j = 0; j < tagList.length; j++) {
												recoHTML += '<li><a href="/howto/garden/tag/' + tagList[j]._key + '/">' + tagList[j].cf_gmt_name + '</a></li>';
											}
											recoHTML += '</ul>';
										}
									}
									recoHTML += '</div></li>';
								}
							}
							$('.js-recommend').append(recoHTML);
							$('.js-recommendBlock').removeClass('di_none');
						}
					});
				}
			}
		},
		gardenDetailCalendar: function gardenDetailCalendar() {
			if (DCM.va.pathname.indexOf('/howto/garden/') !== -1) {

				if ($('.howto-detail').length) {
					// 育て方カレンダーのデータがない場合は非表示
					if ($('.rt_bn_calendar_item_1').length === 0) {
						$('.calendar').remove();
					}

					// タブ２個目のデータがない場合は二個目の枠を削除
					if ($('.rt_bn_calendar_item_2').length === 0) {
						$('.rt_bn_calendar_item_2_is').remove();
						$('.mod-tabChange-in_print').remove();
					}

					// 「特長」が空の場合見出しごと消す
					if ($('.rt_cf_gm_feature').length === 0) {
						$('.howto-detail-feature').remove();
					}

					// メイン画像が1枚のみの場合、slick-dotsを非表示
					if ($('.rt_cf_gm_main_img2_is').length === 0) {
						$('.howto-detail-main .slick-dots').remove();
					}

					if ($('.rt_cf_gm_place_is').length === 0 && $('.cf_gm_watering_is').length === 0 && $('.rt_cf_gm_fertilizer_is').length === 0 && $('.rt_cf_gm_pest_is').length === 0 && $('.rt_cf_gm_soil_is').length === 0 && $('.rt_cf_gm_planting_is').length === 0 && $('.rt_cf_gm_replanting_is').length === 0 && $('rt_cf_gm_increase_is').length === 0 && $('.rt_cf_gm_summer_is').length === 0 && $('.rt_cf_gm_winter_is').length === 0) {
						$('.howto-detail-howtoraise').remove();
					}
				}
			}
		},
		guideClasses: function guideClasses() {
			if (DCM.va.pathname.indexOf('/howto/guide/') !== -1) {
				if (DCM.va.pathname !== '/howto/guide/' && DCM.va.pathname !== '/howto/guide/index.html') {
					// 各記事一覧
					$('.mod-head01').addClass('howto-guide-color-' + DCM.va.pathname.split('/')[3]);

					// 詳細
					$('.rt_cf_b_type_is_4 .mod-bclo-title-lg').addClass('howto-guide-color-' + DCM.va.pathname.split('/')[3]);
					$('.bclo-title-lg').addClass('howto-guide-color-' + DCM.va.pathname.split('/')[3]);
				}
			}
		},
		searchKeyword: function searchKeyword() {
			if ($('.js-howto-garden-search-btn').length) {
				var form = $('.js-howto-garden-search-form');
				var btn = $('.js-howto-garden-search-btn');
				var input = $('.js-howto-garden-search-input');
				var replaceKeyword = void 0;
				btn.on('click', function () {
					replaceKeyword = input.val().replace(/　/g, ' ');
					input.val(replaceKeyword);
					form.submit();
				});
			}
		},

		// <快適生活ガイド・ガーデンメモ>詳細ページ
		howtoDetailTable: function howtoDetailTable() {
			if ($('.howto-detail').length) {
				// 横スクロールバー付きの.mod-tbl02上部にスクロールバーを作成
				if ($('.mod-tblWrap .mod-tbl02').length) {
					$('.mod-tbl02').parent('.mod-tblWrap').before('<div class="mod-tbl02-jsScrollBar">\n\t\t\t\t\t\t<div class="mod-tbl02-jsScrollBar-inner"></div></div>');

					$(window).on('resize', function () {
						$('.mod-tbl02-jsScrollBar-inner').css('width', $('.mod-tbl02').outerWidth() + 'px');
					}).resize();

					// 上下の横スクロールを連動
					$('.mod-tbl02').parent('.mod-tblWrap').on('scroll', function (e) {
						$('.mod-tbl02-jsScrollBar').scrollLeft($(e.currentTarget).scrollLeft());
					});
					$('.mod-tbl02-jsScrollBar').on('scroll', function (e) {
						$('.mod-tbl02').parent('.mod-tblWrap').scrollLeft($(e.currentTarget).scrollLeft());
					});
				}

				// 横スクロールバー付きの.mod-tbl03上部にスクロールバーを作成
				if ($('.mod-tblWrap .mod-tbl03').length) {
					$('.mod-tbl03').parent('.mod-tblWrap').before('<div class="mod-tbl03-jsScrollBar">\n\t\t\t\t\t\t<div class="mod-tbl03-jsScrollBar-inner"></div></div>');

					$(window).on('resize', function () {
						$('.mod-tbl03-jsScrollBar-inner').css('width', $('.mod-tbl03').outerWidth() + 'px');
					}).resize();

					// 上下の横スクロールを連動
					$('.mod-tbl03').parent('.mod-tblWrap').on('scroll', function (e) {
						$('.mod-tbl03-jsScrollBar').scrollLeft($(e.currentTarget).scrollLeft());
					});
					$('.mod-tbl03-jsScrollBar').on('scroll', function (e) {
						$('.mod-tbl03').parent('.mod-tblWrap').scrollLeft($(e.currentTarget).scrollLeft());
					});
				}
			}
		},

		// <快適生活ガイドindex、list切り替え
		guideChange: function guideChange() {
			if ($('.howto-guide-change').length) {
				var boxBtn = $('.js-howto-guide-change-box');
				var listBtn = $('.js-howto-guide-change-list');
				var block = $('.js-howto-guide-change-block');
				var isList = 'is-list';
				boxBtn.on('click', function () {
					if (!boxBtn.hasClass(a)) {
						boxBtn.addClass(a);
						listBtn.removeClass(a);
						block.removeClass(isList);
					}
				});
				listBtn.on('click', function () {
					if (!listBtn.hasClass(a)) {
						boxBtn.removeClass(a);
						listBtn.addClass(a);
						block.addClass(isList);
					}
				});
			}
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.gardenMainSlide();
			_this.gardenDetailRecommend();
			_this.gardenDetailCalendar();
			_this.guideClasses();
			_this.searchKeyword();
			_this.howtoDetailTable();
			_this.guideChange();
		}
	};

	$(function () {
		return DCM.loadDelayScript();
	});
})(window.jQuery, window.DCM, window.cssua);